module.exports = __webpack_public_path__ + "img/TaxTim.0e97c6ee.png";